import { plugin, debug } from 'light-component';
import { useEffect, useState, type ReactElement } from 'react';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { Require, Select } from '../component';
import styles from './style.module.less';
import type { SelectOption, MultiSelectProps } from './types';

export function WidgetMultiSelect(props: MultiSelectProps): ReactElement {
  debug.widget('dashboard multiSelect', props);
  const [options, setOptions] = useState<SelectOption[]>([]);
  const { isTranslate = true } = props;
  useEffect(() => {
    if (props.options?.length > 0) {
      let options = props.options?.map(item => ({
        value: item.value,
        label: isTranslate ? t(item.title) : item.title
      }));
      if (props.sort === true) {
        options?.sort((prev, cur) => prev.label.localeCompare(cur.label));
      }
      const uniqueValue = new Set(options?.map(item => item.value));
      options = options?.filter(item => uniqueValue.delete(item.value));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [props.options]);

  if (props.mode === 'thumbnail') {
    return (<ThumbnailMultiSelect />);
  }

  const handleChange = (newValue: string[]): void => {
    if (props.emptyValue !== undefined && newValue.length === 0) {
      props.onChange?.(props.emptyValue);
    } else {
      props.onChange?.(newValue.length > 0 ? newValue : undefined);
    }
  };

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Select
        className={styles.selectBox}
        mode='multiple'
        value={props.value}
        placeholder={t(props.placeholder ?? '')}
        options={options}
        selectAll={props.value?.length === options.length}
        allowClear
        maxTagCount={props.maxTagCount}
        onChange={handleChange}
      />
    </div>
  );
}

function ThumbnailMultiSelect(): ReactElement {
  return (
    <div className={styles.control}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'multiselect', component: WidgetMultiSelect });
